import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import gaTracker from 'src/utils/gaTracker';
import { useHostAppProxy } from 'src/contexts/HostAppProxyContext';
import { useSelector } from 'react-redux';
import { featureToggleUtil } from 'src/utils';
import { useFeatureFlags } from 'src/hooks/useFeatureFlags';

// stateless component
const UpgradeToUnlock = () => {
  const {
    settings: { showPaymentInfo, isWrapped },
  } = useHostAppProxy();
  const userProfile = useSelector((state: any) => state.user.userProfile);
  const { flags } = useFeatureFlags();
  const canShowPaymentInfo = featureToggleUtil.shouldShowPaymentInfo(
    userProfile,
    { showPaymentInfo, isWrapped },
    flags?.ios_iap === true
  );
  const { t } = useTranslation();

  return canShowPaymentInfo ? (
    <Link to={'/products'} style={{ color: 'orange' }}>
      <em>
        {t('UpgradeToUnlock')} <Icon name="lock" />
      </em>
    </Link>
  ) : (
    <span style={{ color: 'orange' }}>
      <em>
        {t('ThisIsAPremiumFeature')} <Icon name="lock" />
      </em>
    </span>
  );
};
export default UpgradeToUnlock;
